import axios from 'axios'
import { Message } from 'element-ui'
import { BIZ_TOKEN, BIZ_USERINFO } from '@/common/constant'

/**
 * IM HTTP 请求实例
 * - baseURL 指向 bizspring 网关的 upms 服务前缀 /upms
 * - 鉴权复用用户PC端登录态：Authorization Bearer + UserId + username
 *   （与 src/util/http.js 的 mergeShopAuthHeaders 保持一致，实现「用户与PC端用户衔接」）
 */
const http = axios.create({
	baseURL: '/upms',
	timeout: 1000 * 30
})

function readToken() {
	return localStorage.getItem(BIZ_TOKEN) || sessionStorage.getItem(BIZ_TOKEN) || ''
}

function readMember() {
	const raw = sessionStorage.getItem(BIZ_USERINFO) || localStorage.getItem(BIZ_USERINFO)
	if (!raw) return null
	try {
		const u = JSON.parse(raw)
		return { id: u.id, username: u.username || u.mobile || '' }
	} catch (e) {
		return null
	}
}

/**
 * 请求拦截：注入 bizspring 鉴权头
 */
http.interceptors.request.use(config => {
	const token = readToken()
	if (token) {
		config.headers['Authorization'] = 'Bearer ' + token
	}
	const mem = readMember()
	if (mem && mem.id) {
		config.headers['UserId'] = mem.id
		config.headers['username'] = mem.username
	}
	return config
}, error => {
	return Promise.reject(error)
})

/**
 * 响应拦截：解包 bizspring R 结构 {code,data,msg}
 */
http.interceptors.response.use(response => {
	const body = response.data
	if (body && typeof body === 'object' && 'code' in body) {
		if (body.code === 200) {
			return body.data
		}
		if (body.code === 10003) {
			return Promise.reject(body)
		}
		Message({
			message: body.message || body.msg || '请求失败',
			type: 'error',
			duration: 1500,
			customClass: 'element-error-message-zindex'
		})
		return Promise.reject(body)
	}
	// 非标准 R 结构，直接返回 body
	return body
}, error => {
	const status = error && error.response && error.response.status
	if (status === 404 || status === 500) {
		Message({
			message: '服务器出了点小差，请稍后再试',
			type: 'error',
			duration: 1500,
			customClass: 'element-error-message-zindex'
		})
	}
	return Promise.reject(error)
})

export default http
